











































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import HotkeyLegend from '@/layouts/gripper/hotkeys/HotkeyLegend.vue';
import OptionListItem from '@/layouts/gripper/components/QuickLabeling/OptionListItem.vue';
import {Option} from '@/types/gripper';
import HotkeyListener from '@/layouts/gripper/hotkeys/HotkeyListener.vue';

@Component({
  components: {HotkeyListener, OptionListItem, HotkeyLegend},
})

export default class OptionSideBar extends Vue {
  @Prop(Array) public allPossibleOptions!: Option[];
  @Prop(Object) public selectedParameterOption!: Option;
  @Prop(String) public title?: string;

  private indexInArray: number = 0;
  private hideLabels: boolean = false;
  private searchFilterString: string = '';
  get allPossibleOptionsFiltered(): Option[] {
    if (this.searchFilterString === '') {
      return this.allPossibleOptions;
    }

    const filteredResult: Option[] = [];
    this.allPossibleOptions.forEach((option: Option) => {
      if (option.value.toLowerCase().includes(this.searchFilterString.toLowerCase())) {
        filteredResult.push(option);
      }
    });

    return filteredResult;
  }

  private get getViewPortWidth() {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    return vw;
  }

  private get isIpadOrPhone() {
    if (this.getViewPortWidth <= 1368) {
      return true;
    }
    return false;
  }

  private changeOption(option: Option) {
    this.indexInArray = this.allPossibleOptionsFiltered.findIndex((i: Option) => i.value === option.value);
    this.$emit('onClickChangeOption', option);
  }

  private keyListener(origin: KeyboardEvent) {
    switch (origin.key) {
      case ']':
        // Check if we can traverse to a lower row
        if (this.indexInArray + 1 < this.allPossibleOptionsFiltered.length) {
          this.changeOption(this.allPossibleOptionsFiltered[this.indexInArray + 1]);
        }
        break;
      case '[':
        // Check if we can traverse to an upper row
        if (this.indexInArray > 0) {
          this.changeOption(this.allPossibleOptionsFiltered[this.indexInArray - 1]);
        }
        break;
    }
  }

}

